import request from '@/utils/request'

// 智能决策机器人
export function getRobotData(data) {
  return request({
    url: '/promotion/smart/getDataStat',
    method: 'post',
    data
  }).then(res => res.data.result || {})
}
// 拉新分析接口
export function getOrderDataStat(data) {
  return request({
    url: '/promotion/smart/getOrderDataStat',
    method: 'post',
    data
  }).then(res => res.data.result || {})
}

// 复购接口
export function getRepurchaseDataStat(data) {
  return request({
    url: '/promotion/smart/getRepurchaseDataStat',
    method: 'post',
    data
  }).then(res => res.data.result || {})
}

// 查询活动列表接口
export function getPromotionList(data) {
  return request({
    url: '/promotion/smart/getPromotionList',
    method: 'post',
    data
  }).then(res => res.data.result || {})
}

// 会员营销分析接口
export function getMemberMarketDataStat(data) {
  return request({
    url: '/promotion/smart/getMemberMarketDataStat',
    method: 'post',
    data
  }).then(res => res.data.result || {})
}

// 建议查询接口
export function getSuggestData(data) {
  return request({
    url: '/promotion/smart/querySaasSuggestByType',
    method: 'post',
    data
  }).then(res => res.data.result || {})
}

// 获取物料二维码地址
export function getQrCodePicUrl(data) {
  return request({
    url: '/promotion/smart/getQrCodePicUrl',
    method: 'post',
    data
  }).then(res => res.data.result || {})
}
